import { useRegularityPanel } from '../../Hooks/Features/employeeDashboard/useRegularityPanel';
import { SkeletonContainer } from '../Loader/Loader';
import { Dialog } from 'primereact/dialog';
import TaptikHistory from './TaptikHistory';
import { ProgressBar } from 'primereact/progressbar';

const RegularityPanel = () => {

    const { loader, popupOpne, setPopupOpen, showHistory, setShowHistory, selectedEmployee, getAttandanceLeaveDetails, puncJson } = useRegularityPanel();

    return (
        <div className='w100 employee-dash-height position-relative'>
            {loader ?
                <div className='w100' style={{ height: '100%' }}>
                    <SkeletonContainer />
                </div>
                : <div className='punctuality-widget-container'>
                    {puncJson?.map((item, idx) => (
                        <div key={idx} className='text-center align-content-center'>
                            <div style={{ fontSize: "0.9em" }}>{item?.icon}</div>
                            {item?.valueLabel ? <div style={{ fontSize: "0.9em" }} className={`fw-semibold ${(item?.title !== "Leave" && item?.title !== "Timesheet") ? "c-pointer" : ""} text-truncate`} onClick={() => { if (item?.title === "Punctuality") { getAttandanceLeaveDetails() } else if (item?.title !== "Leave" && item?.title !== "Timesheet") { setShowHistory(true) } }}>{item?.valueLabel}</div>
                                :
                                <div style={{ fontSize: "0.9em" }}>-</div>
                            }
                            <div style={{ fontSize: "0.8em" }} className='text-truncate'>{item?.title}</div>
                            {item?.progress && item?.value?.map((prog, index) => (
                                <div key={index} style={{ marginBottom: "2px" }} title={`${prog}%`}>
                                    <ProgressBar value={prog} style={{ height: "4px" }} className='w95 punctuality-widget-blue-progress' />
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            }


            {showHistory && <TaptikHistory showHistory={showHistory} setShowHistory={setShowHistory} userId={selectedEmployee?.user_code} />}

            <Dialog
                className='timesheet-dialog'
                modal={true}
                draggable={false}
                style={{ width: '70vw', minHeight: "70%" }}
                visible={popupOpne?.show}
                onHide={() => setPopupOpen({ show: false, data: null })}
                header={() => { return (<div> Punctuality Details </div>); }}
            >
                <div dangerouslySetInnerHTML={{ __html: popupOpne?.data?.column1 }}></div>
            </Dialog >
        </div>
    )
}

export default RegularityPanel